var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.75 1.5H7.25C3.5 1.5 2 3 2 6.75V11.25C2 15 3.5 16.5 7.25 16.5H11.75C15.5 16.5 17 15 17 11.25V9.75",
    stroke: "#12589F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5299 2.26495L6.61991 8.17495C6.39491 8.39995 6.16991 8.84245 6.12491 9.16495L5.80241 11.4224C5.68241 12.2399 6.25991 12.8099 7.07741 12.6974L9.33491 12.3749C9.64991 12.3299 10.0924 12.1049 10.3249 11.8799L16.2349 5.96995C17.2549 4.94995 17.7349 3.76495 16.2349 2.26495C14.7349 0.764945 13.5499 1.24495 12.5299 2.26495Z",
    stroke: "#12589F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.6826 3.1123C12.1851 4.9048 13.5876 6.3073 15.3876 6.8173",
    stroke: "#12589F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1344a92debef507a9e35d92b66fa6f83.svg";
export { ForwardRef as ReactComponent };